export var LegendDisplayMode;
(function (LegendDisplayMode) {
    LegendDisplayMode["List"] = "list";
    LegendDisplayMode["Table"] = "table";
    LegendDisplayMode["Hidden"] = "hidden";
})(LegendDisplayMode || (LegendDisplayMode = {}));
//# sourceMappingURL=types.js.map